import React from 'react'
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';

const renderReactStrapField = ({ classNameField = '', input, hide, hidden, disabled, label, type, rows, props, handleonChange, meta: { asyncValidate, touched, error, warning } }) => {
      const handleChange = (e) => {
        input.onChange(e); 
        if (handleonChange) {
            handleonChange(e);
        }
    };

    return <FormGroup style={{ marginTop: hidden ? '-37px' : '0px', display: hide === true ? 'none' : '' }} className={asyncValidate ? `async-validating ${classNameField}` : classNameField}>
        <Label for={label}>{label}</Label>
        <Input  {...input} {...props} onChange={handleChange} disabled={disabled} hidden={hidden} invalid={(touched && error) || (warning)} type={type} placeholder={label} rows={rows} />
        <FormFeedback>{error}</FormFeedback>
    </FormGroup>
}
export default renderReactStrapField